module.exports = __webpack_public_path__ + "img/ic_24_question.9064b131.svg";